import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { ComponentVariantTransform, type Variants } from '../../../utils/variant/variant';

@Component({
  selector: 'rt-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'variant()',
  },
  standalone: true,
})
export class ProgressBarComponent {
  public static readonly VARIANTS: Variants = [
    'indeterminate',
    ['indeterminate', 'fixed', 'light', 'automated-actions'],
  ];

  public readonly variant = input(...ComponentVariantTransform(ProgressBarComponent.VARIANTS));
}
